<div class="lp-canvas-element" style="width: 100%; height: 100%; position: relative">
  <div
    class="animator"
    [class.bubble]="context.isBubbling()"
    [class.pulse]="context.isPulsing()"
    style="width: 100%; height: 100%"
    [style.transform-origin]="el().pivot.x * 100 + '% ' + (1 - el().pivot.y) * 100 + '%'"
  >
    <div class="wrapper" style="position: relative; width: 100%; height: 100%" [@visibility]="context.visibility()">
      <div class="styles" style="position: relative; width: 100%; height: 100%; isolation: isolate" [style]="ngStyle()">
        <lp-canvas-components [components]="el().components" [context]="context" style="pointer-events: none" />
      </div>
    </div>

    @if (_gameService.enableDebug()) {
      <lp-canvas-element-pivot [pivot]="pivot()" style="position: absolute; inset: 0; z-index: 1" />
    }
  </div>
</div>
